/** Default copy for Learn from Leaders (widget + CMS field defaults). */
export const LFL_DEFAULT_HEADING_LINE_1 = "Learn directly from leaders";
export const LFL_DEFAULT_HEADING_LINE_2 = "shaping your industry";
export const LFL_DEFAULT_DESCRIPTION =
  "Access 300+ CXO-led sessions annually featuring experts from Google, Meta, McKinsey, BCG, Amazon, Mastercard, and more—bringing boardroom insights straight to your learning experience.";
export const LFL_DEFAULT_DESCRIPTION_COLOR = "rgba(255, 255, 255, 0.82)";
